/**
 * Runtime configuration for the standalone build.
 *
 * This module only exists in the standalone (S3) target. Inside New Relic the
 * platform supplies account context and an authenticated NRQL transport, so
 * nothing here is copied into the nerdpack.
 */

const DEFAULT_ENDPOINTS = {
  US: "https://api.newrelic.com/graphql",
  EU: "https://api.eu.newrelic.com/graphql",
};

let runtimeConfig = {
  accountId: null,
  region: "US",
  // Point this at your own proxy to avoid shipping a NerdGraph key to browsers.
  nerdgraphEndpoint: null,
  // "proxy" suppresses the API-Key header entirely; see runNrql.
  authMode: "proxy",
  // Only used when authMode is "apiKey".
  apiKey: null,
  timeRange: { begin_time: null, end_time: null, duration: 30 * 60 * 1000 },
};

export function setRuntimeConfig(next) {
  runtimeConfig = { ...runtimeConfig, ...next };
  return runtimeConfig;
}

export function getRuntimeConfig() {
  return runtimeConfig;
}

export function getEndpoint() {
  return (
    runtimeConfig.nerdgraphEndpoint ||
    DEFAULT_ENDPOINTS[runtimeConfig.region] ||
    DEFAULT_ENDPOINTS.US
  );
}

export { DEFAULT_ENDPOINTS };
